<template>
  <div>

    <div class="container-fluid mt-7">
      <b-card no-body>
        <b-card-header>
          <div class="align-items-center row">
            <div class="col d-flex align-items-center">
              <h3 class="card-title mb-0">{{ $t('Duyurular') }}</h3>
<!--              <div class="text-sm ml-4" style="width:200px;">-->
<!--                <b-form-group class="mb-0">-->
<!--                  <b-form-input placeholder="Arama kelimesi" v-model="keyword" debounce="500"/>-->
<!--                </b-form-group>-->
<!--              </div>-->
            </div>
            <div class="col text-right">
              <b-button @click="openCreateModal" variant="primary">+ {{ $t('Yeni Duyuru Ekle') }}</b-button>
            </div>
          </div>
        </b-card-header>

        <b-table ref="table" class="align-items-center" thead-class="thead-light" :fields="fields" :items="items" responsive :fixed="fixed" show-empty>

          <template v-slot:table-busy>
            <div style="width: 100%; text-align:center;">
              <b-spinner label="Spinning"></b-spinner>
            </div>
          </template>

          <template v-slot:empty>
            <b-alert variant="warning" show>{{ $t('Henüz hiç müşteri eklememişsiniz, hemen yeni bir tane ekleyin!') }}</b-alert>
          </template>
          <template v-slot:cell(description)="data">
            <p v-html="data.item.description"></p>
          </template>
          <template v-slot:cell(created_at)="data">
            {{ data.item.created_at }}
          </template>

          <template v-slot:cell(actions)="data">
            <b-dropdown class="action-button" right>
              <template v-slot:button-content>
                <i class="fas fa-ellipsis-v" />
              </template>
              <b-dropdown-item @click="openUpdateModal(data.item)" class="dropdown-item-icon">
                <i class="fas fa-pen"></i>
                <span>{{ $t('Duyuruyu Güncelle') }}</span>
              </b-dropdown-item>
              <b-dropdown-item @click="deleteAction(data.item.id)" class="dropdown-item-icon">
                <i class="fas fa-trash"></i>
                <span>{{ $t('Sil') }}</span>
              </b-dropdown-item>
            </b-dropdown>
          </template>

        </b-table>

        <!--        <div class="w-100 d-flex align-items-center justify-content-center mt-2 mb-3" v-if="pagination.totalRows > 14">-->
        <!--          <b-pagination v-model="pagination.currentPage" :total-rows="pagination.totalRows" :per-page="pagination.perPage" />-->
        <!--        </div>-->
      </b-card>
      <b-modal ref="createModal" title="Yeni Duyuru">
        <b-input-group >
          <b-input type="text" v-model="newAnnounce.title" placeholder="Duyuru Başlığı"></b-input>
        </b-input-group>
        <b-input-group class="mt-3">
          <ckeditor v-model="newAnnounce.description" editor-url="https://cdn.ckeditor.com/4.16.2/full/ckeditor.js" :config="config"/>
<!--          <b-textarea v-model="newAnnounce.description" placeholder="Duyuru Metni"></b-textarea>-->
        </b-input-group>
        <template v-slot:modal-footer>
          <b-button @click="$refs.createModal.hide()">{{ $t('Vazgeç') }}</b-button>
          <b-button @click="storeNewAnnounce" variant="primary">
            {{ $t('Ekle') }}
          </b-button>
        </template>
      </b-modal>

      <b-modal ref="updateModal" title="Duyuru Düzenle" :no-enforce-focus="false">
        <b-input-group >
          <b-input type="text" v-model="currentItem.title" placeholder="Duyuru Başlığı"></b-input>
        </b-input-group>
        <b-input-group class="mt-3">
          <ckeditor v-model="currentItem.description" editor-url="https://cdn.ckeditor.com/4.16.2/full/ckeditor.js" :config="config"/>

<!--          <b-textarea v-model="currentItem.description" placeholder="Duyuru Metni"></b-textarea>-->
        </b-input-group>
        <template v-slot:modal-footer>
          <b-button @click="$refs.updateModal.hide()">{{ $t('Vazgeç') }}</b-button>
          <b-button @click="updateNewAnnounce(currentItem)" variant="primary">
            {{ $t('Kaydet') }}!
          </b-button>
        </template>
      </b-modal>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
export default {
  name: 'Clients',
  data () {
    return {
      config: {
        language: 'tr',
        height: 500,
        toolbarGroups: [
          { name: 'document', groups: [ 'mode', 'document', 'doctools' ] },
          { name: 'clipboard', groups: [ 'clipboard', 'undo' ] },
          { name: 'editing', groups: [ 'find', 'selection', 'spellchecker', 'editing' ] },
          { name: 'forms', groups: [ 'forms' ] },
          { name: 'basicstyles', groups: [ 'basicstyles', 'cleanup' ] },
          { name: 'paragraph', groups: [ 'list', 'indent', 'blocks', 'align', 'bidi', 'paragraph' ] },
          { name: 'links', groups: [ 'links' ] },
          { name: 'insert', groups: [ 'insert' ] },
          { name: 'styles', groups: [ 'styles' ] },
          { name: 'colors', groups: [ 'colors' ] },
          { name: 'tools', groups: [ 'tools' ] },
          { name: 'others', groups: [ 'others' ] },
          { name: 'about', groups: [ 'about' ] }
        ],
        removeButtons: 'Save,NewPage,ExportPdf,Preview,Print,Templates,Undo,Redo,Find,Replace,SelectAll,Scayt,Form,Checkbox,Radio,TextField,Textarea,Select,Button,ImageButton,HiddenField,PasteFromWord,CreateDiv,Language,Image,Flash,Iframe,About,ShowBlocks',
      },
      newAnnounce:{},
      totalCredit: 0,
      totalDebt: 0,
      keyword: '',
      currentItem:{},
      type: '',
      pagination: {
        currentPage: 1,
        totalRows: 1,
        perPage: 15,
      },
      types: [],
      fields: [
        { key: 'title', label: this.$t('Başlık') },
        { key: 'description', label: this.$t('Açıklama') },
        { key: 'created_at', label: this.$t('Tarih') },
        // { key: 'company_name', label: 'Firma Adı' },
        // { key: 'balance', label: 'Bakiye' },
        { key: 'actions', label: '', tdClass: 'text-right' },
      ]
    }
  },
  methods: {
    ...mapActions(['getClients', 'deleteClient','getAnnounces','deleteAnnounce','createAnnounce','updateAnnounce']),
    items() {
      const parameters = this.parameters();
      return this.getAnnounces(parameters).then(data => data.data).then(res => {

        return res;
      });
    },
    refreshTable() {
      this.$refs.table.refresh()
    },
    parameters() {
      const params = {};
      if( this.keyword.length > 0 ) {
        params.keyword = this.keyword;
      }
      if( this.type ) {
        params.type = this.type;
      }
      return params;
    },
    openUpdateModal(item){
      this.currentItem=item
      console.log(this.currentItem)
      this.$refs.updateModal.show()

    },
    storeNewAnnounce(){
      this.createAnnounce(this.newAnnounce).then(res=>{
        this.refreshTable();
        this.success("Başarılı!");
        this.newAnnounce={};
        this.$refs.createModal.hide()
      }).catch(err=>{
        this.$swal('Hata','Başlık ve Açıklama Kısmını Doldurunuz!','error');
      })
    },
    updateNewAnnounce(){
      this.updateAnnounce({id:this.currentItem.id , item:this.currentItem}).then(res=>{
        this.refreshTable();
        this.success("Başarılı!");
        this.newAnnounce={};
        this.$refs.createModal.hide()
      }).catch(err=>{
        this.$swal('Hata','Başlık ve Açıklama Kısmını Doldurunuz!','error');
      })
    },
    openCreateModal(){
      this.$refs.createModal.show()
    },
    deleteAction(id) {
      this.deleteAnnounce(id).then(() => {
        this.refreshTable();
      })
    }
  },
  watch: {
    keyword() {
      this.refreshTable();
    },
  }
}
</script>
